import { useMutation } from 'react-query';

import { resendInviteEmail as mutationFn } from 'api/endPoints/resendInviteEmail';

const useResendInviteMutation = () => {
    return useMutation<unknown, QueryError, string>((params) => mutationFn(params));
};

export { useResendInviteMutation };
